import React from 'react'
import Hero from './components/Hero'
import Details from './components/Details'

const Volunteer = () => {
  return (
    <div>
        <Hero />
        <Details />
    </div>
  )
}

export default Volunteer